import { Controller } from "@hotwired/stimulus"

// Monthly/annual price switch on the pricing page. Both price strings are
// rendered up front (no fetch, no recompute), this just toggles which one
// shows. The page is rendered with Annual already selected (see
// pages/pricing/_tiers), so the annual price is what's visible without JS
// and there is no flash on load.
export default class extends Controller {
  static targets = ["monthlyButton", "annualButton", "monthlyPrice", "annualPrice"]

  showMonthly() {
    this.#setInterval("monthly")
  }

  showAnnual() {
    this.#setInterval("annual")
  }

  #setInterval(interval) {
    const annual = interval === "annual"

    this.monthlyButtonTarget.classList.toggle("is-active", !annual)
    this.annualButtonTarget.classList.toggle("is-active", annual)
    this.monthlyPriceTargets.forEach((el) => el.classList.toggle("d-none", annual))
    this.annualPriceTargets.forEach((el) => el.classList.toggle("d-none", !annual))
  }
}
